export default {
  path: 'reset-password/:token',
  name: 'ResetPassword',
  component: () => import(/* webpackChunkName: "Login" */ '@/app/auth/resetPassword/ResetPasswordContainer.vue'),
  meta: {
    title: 'TV24 | resetowanie hasła',
    public: true,
    onlyWhenLoggedOut: true,
  },
};
